<template>
  <PreviewWrapper class="text-center p-20">
    <h5 class="text-break fs-dbb-20 mb-0">
      {{ passwordPageTitle || $t("website.managePage.pageAddEdit.permission.password.preview.lblDefaultTitle", languageUse) }}
    </h5>
    <p class="small text-break mt-5">
      {{ passwordPageSubtitle || $t("website.managePage.pageAddEdit.permission.password.preview.lblDefaultSubTitle", languageUse) }}
    </p>
    <div class="d-flex justify-content-center mt-10">
      <b-form-input
        class="w-75"
        style="background: #ffffff"
        type="password"
        :value="password"
        placeholder="*****"
        readonly
        disabled
      />
    </div>
    <!-- <WrapperWidgetButton
      :custom_style="templateButton"
      :class="`d-flex justify-content-center`"
    > -->
    <button class="btn btn-secondary button-preview-website mt-10" disabled>
      {{ passwordPageButton || $t("website.managePage.pageAddEdit.permission.password.preview.lblDefaultBtn", languageUse) }}
    </button>
    <!-- </WrapperWidgetButton> -->
  </PreviewWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import styled from "vue-styled-components";
// import color from "@helpers/color.helper";
const PreviewWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #ced4da;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
  overflow: hidden;
  line-height: 1;
`;

export default {
  components: {
    PreviewWrapper,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters({
      templateButton: "design/metadata/templateButton",
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
    }),
    password: {
      get() {
        return this.data.properties.permission.password;
      },
      set(val) {
        this.data.properties.permission.password = val;
      }
    },
    passwordPageTitle: {
      get() {
        return this.data.properties.permission.passwordPageTitle;
      },
      set(val) {
        this.data.properties.permission.passwordPageTitle = val;
      }
    },
    passwordPageSubtitle: {
      get() {
        return this.data.properties.permission.passwordPageSubtitle;
      },
      set(val) {
        this.data.properties.permission.passwordPageSubtitle = val;
      }
    },
    passwordPageButton: {
      get() {
        return this.data.properties.permission.passwordPageButton;
      },
      set(val) {
        this.data.properties.permission.passwordPageButton = val;
      }
    },
  },
};
</script>

<style lang="scss" scope>
.button-preview-website {
  width: auto;
  min-width: 100px;
  max-width: 75%;
  overflow-wrap: anywhere;
  font-family: "Sarabun";
  font-size: 12px;
  color: #ffffff;
  background-color: #373e44;
  border-color: #373e44;
  border-radius: 4px;
}
.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff;
  background-color: #373e44;
  border-color: #373e44;
}
/* transition: all 0.3s ease; */
</style>